//
// Copyright (c) 2020 Practice Insight Pty Ltd. All rights reserved.
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wt/svc/shared/shared.proto (package wt_srv_shared, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wt/svc/shared/shared.proto.
 */
export const file_wt_svc_shared_shared: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * See https://stripe.com/docs/checkout#integration-simple-parameters
 *
 * @generated from message wt_srv_shared.Address
 */
export type Address = Message<"wt_srv_shared.Address"> & {
  /**
   * From stripeBillingName
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * From stripeBillingAddressLine1
   *
   * @generated from field: string address_line_1 = 2;
   */
  addressLine1: string;

  /**
   * From stripeBillingAddressLine2
   *
   * @generated from field: string address_line_2 = 7;
   */
  addressLine2: string;

  /**
   * From stripeBillingAddressZip
   *
   * @generated from field: string postal_code = 3;
   */
  postalCode: string;

  /**
   * From stripeBillingAddressState
   *
   * @generated from field: string state = 4;
   */
  state: string;

  /**
   * From stripeBillingAddressCity
   *
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * From stripeBillingAddressCountry
   *
   * @generated from field: string country_code = 6;
   */
  countryCode: string;
};

/**
 * Describes the message wt_srv_shared.Address.
 * Use `create(AddressSchema)` to create a new message.
 */
export const AddressSchema: GenMessage<Address> = /*@__PURE__*/
  messageDesc(file_wt_svc_shared_shared, 0);

/**
 * @generated from message wt_srv_shared.TeamIdMsg
 */
export type TeamIdMsg = Message<"wt_srv_shared.TeamIdMsg"> & {
  /**
   * Required
   *
   * @generated from field: string team_id = 1;
   */
  teamId: string;
};

/**
 * Describes the message wt_srv_shared.TeamIdMsg.
 * Use `create(TeamIdMsgSchema)` to create a new message.
 */
export const TeamIdMsgSchema: GenMessage<TeamIdMsg> = /*@__PURE__*/
  messageDesc(file_wt_svc_shared_shared, 1);

/**
 * @generated from message wt_srv_shared.GenericResultMessage
 */
export type GenericResultMessage = Message<"wt_srv_shared.GenericResultMessage"> & {
  /**
   * @generated from field: wt_srv_shared.GenericResult status = 1;
   */
  status: GenericResult;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message wt_srv_shared.GenericResultMessage.
 * Use `create(GenericResultMessageSchema)` to create a new message.
 */
export const GenericResultMessageSchema: GenMessage<GenericResultMessage> = /*@__PURE__*/
  messageDesc(file_wt_svc_shared_shared, 2);

/**
 * The JSON representation for `Empty` is empty JSON object `{}`.
 *
 * @generated from message wt_srv_shared.EmptyMsg
 */
export type EmptyMsg = Message<"wt_srv_shared.EmptyMsg"> & {
};

/**
 * Describes the message wt_srv_shared.EmptyMsg.
 * Use `create(EmptyMsgSchema)` to create a new message.
 */
export const EmptyMsgSchema: GenMessage<EmptyMsg> = /*@__PURE__*/
  messageDesc(file_wt_svc_shared_shared, 3);

/**
 * @generated from message wt_srv_shared.Connector
 */
export type Connector = Message<"wt_srv_shared.Connector"> & {
  /**
   * @generated from field: string connector_name = 1;
   */
  connectorName: string;

  /**
   * @generated from field: repeated string api_keys = 2;
   */
  apiKeys: string[];

  /**
   * @generated from field: wt_srv_shared.ReceivePostedTimeStatus receive_posted_time = 4;
   */
  receivePostedTime: ReceivePostedTimeStatus;

  /**
   * @generated from field: string connector_label = 5;
   */
  connectorLabel: string;

  /**
   * @generated from field: string team_id = 6;
   */
  teamId: string;

  /**
   * @generated from field: wt_srv_shared.ConnectorHeartbeatStatus heartbeatStatus = 7;
   */
  heartbeatStatus: ConnectorHeartbeatStatus;

  /**
   * @generated from field: wt_srv_shared.ConnectorAuthType connector_auth_type = 9;
   */
  connectorAuthType: ConnectorAuthType;

  /**
   * @generated from field: wt_srv_shared.ConnectorType external_system_type = 10;
   */
  externalSystemType: ConnectorType;

  /**
   * mapped from external_system_type (ConnectorType)
   *
   * @generated from field: wt_srv_shared.ManagementSystemType management_system_type = 11;
   */
  managementSystemType: ManagementSystemType;
};

/**
 * Describes the message wt_srv_shared.Connector.
 * Use `create(ConnectorSchema)` to create a new message.
 */
export const ConnectorSchema: GenMessage<Connector> = /*@__PURE__*/
  messageDesc(file_wt_svc_shared_shared, 4);

/**
 * @generated from message wt_srv_shared.ConnectorAccessToken
 */
export type ConnectorAccessToken = Message<"wt_srv_shared.ConnectorAccessToken"> & {
  /**
   * @generated from field: string external_access_token = 1;
   */
  externalAccessToken: string;

  /**
   * @generated from field: google.protobuf.Timestamp expiry_time = 2;
   */
  expiryTime?: Timestamp;

  /**
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message wt_srv_shared.ConnectorAccessToken.
 * Use `create(ConnectorAccessTokenSchema)` to create a new message.
 */
export const ConnectorAccessTokenSchema: GenMessage<ConnectorAccessToken> = /*@__PURE__*/
  messageDesc(file_wt_svc_shared_shared, 5);

/**
 * @generated from enum wt_srv_shared.Currency
 */
export enum Currency {
  /**
   * @generated from enum value: CURRENCY_UNSPECIFIED = 0;
   */
  CURRENCY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUD = 1;
   */
  AUD = 1,

  /**
   * @generated from enum value: EUR = 2;
   */
  EUR = 2,

  /**
   * @generated from enum value: USD = 3;
   */
  USD = 3,

  /**
   * @generated from enum value: GBP = 4;
   */
  GBP = 4,
}

/**
 * Describes the enum wt_srv_shared.Currency.
 */
export const CurrencySchema: GenEnum<Currency> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 0);

/**
 * *
 * Note some code relies on enum value to determine if upgrade or downgrade - amend with caution.
 * New subscription types likely need to be handled via aliasing to (new set of) enum values).
 * Team type is called "subscription_type" in newer code, and team_type in legacy code.
 *
 * @generated from enum wt_srv_shared.TeamType
 */
export enum TeamType {
  /**
   * @generated from enum value: TEAM_TYPE_UNSPECIFIED = 0;
   */
  TEAM_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: STARTER = 1 [deprecated = true];
   * @deprecated
   */
  STARTER = 1,

  /**
   * @generated from enum value: PROFESSIONAL = 2;
   */
  PROFESSIONAL = 2,

  /**
   * @generated from enum value: ENTERPRISE = 3;
   */
  ENTERPRISE = 3,
}

/**
 * Describes the enum wt_srv_shared.TeamType.
 */
export const TeamTypeSchema: GenEnum<TeamType> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 1);

/**
 * Billing cycle for a subscription plan.
 *
 * @generated from enum wt_srv_shared.PlanCycle
 */
export enum PlanCycle {
  /**
   * @generated from enum value: PLAN_CYCLE_UNSPECIFIED = 0;
   */
  PLAN_CYCLE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MONTHLY = 1;
   */
  MONTHLY = 1,

  /**
   * @generated from enum value: QUARTERLY = 2;
   */
  QUARTERLY = 2,

  /**
   * @generated from enum value: HALF_YEARLY = 4;
   */
  HALF_YEARLY = 4,

  /**
   * @generated from enum value: YEARLY = 3;
   */
  YEARLY = 3,
}

/**
 * Describes the enum wt_srv_shared.PlanCycle.
 */
export const PlanCycleSchema: GenEnum<PlanCycle> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 2);

/**
 * @generated from enum wt_srv_shared.GenericResult
 */
export enum GenericResult {
  /**
   * @generated from enum value: GENERIC_RESULT_UNSPECIFIED = 0;
   */
  GENERIC_RESULT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESULT_FAILED = 1;
   */
  RESULT_FAILED = 1,

  /**
   * @generated from enum value: RESULT_SUCCESS = 2;
   */
  RESULT_SUCCESS = 2,

  /**
   * In some cases email sending is skipped altogether i.e. known demo email accounts
   *
   * @generated from enum value: RESULT_SKIPPED = 3;
   */
  RESULT_SKIPPED = 3,
}

/**
 * Describes the enum wt_srv_shared.GenericResult.
 */
export const GenericResultSchema: GenEnum<GenericResult> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 3);

/**
 * *
 * Heartbeat state of the connector.
 *
 * @generated from enum wt_srv_shared.ConnectorHeartbeatStatus
 */
export enum ConnectorHeartbeatStatus {
  /**
   * @generated from enum value: ALARM_STATUS_UNSPECIFIED = 0;
   */
  ALARM_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: ALARM = 2;
   */
  ALARM = 2,
}

/**
 * Describes the enum wt_srv_shared.ConnectorHeartbeatStatus.
 */
export const ConnectorHeartbeatStatusSchema: GenEnum<ConnectorHeartbeatStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 4);

/**
 * @generated from enum wt_srv_shared.ConnectorType
 */
export enum ConnectorType {
  /**
   * @generated from enum value: CONNECTOR_TYPE_UNSPECIFIED = 0;
   */
  CONNECTOR_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLIO = 1;
   */
  CLIO = 1,

  /**
   * @generated from enum value: INPROTECH = 2;
   */
  INPROTECH = 2,

  /**
   * @generated from enum value: INSIGHTLY = 3;
   */
  INSIGHTLY = 3,

  /**
   * @generated from enum value: INTERASCO_EFILIA = 4;
   */
  INTERASCO_EFILIA = 4,

  /**
   * @generated from enum value: JIRA = 5;
   */
  JIRA = 5,

  /**
   * @generated from enum value: PATRICIA = 6;
   */
  PATRICIA = 6,

  /**
   * @generated from enum value: PATRAWIN = 7;
   */
  PATRAWIN = 7,

  /**
   * @generated from enum value: JIRA_CLOUD = 8 [deprecated = true];
   * @deprecated
   */
  JIRA_CLOUD = 8,

  /**
   * @generated from enum value: PRACTICE_PANTHER = 10;
   */
  PRACTICE_PANTHER = 10,

  /**
   * @generated from enum value: ROCKET_MATTER = 11;
   */
  ROCKET_MATTER = 11,

  /**
   * @generated from enum value: QUICKBOOKS = 12;
   */
  QUICKBOOKS = 12,

  /**
   * @generated from enum value: MITRATECH = 13;
   */
  MITRATECH = 13,

  /**
   * @generated from enum value: LAWCUS = 14;
   */
  LAWCUS = 14,

  /**
   * @generated from enum value: ACTIONSTEP = 15;
   */
  ACTIONSTEP = 15,

  /**
   * @generated from enum value: DYNAMICS_365_BUSINESS_CENTRAL_ON_PREM = 16;
   */
  DYNAMICS_365_BUSINESS_CENTRAL_ON_PREM = 16,

  /**
   * @generated from enum value: DYNAMICS_365_BUSINESS_CENTRAL_CLOUD = 18;
   */
  DYNAMICS_365_BUSINESS_CENTRAL_CLOUD = 18,

  /**
   * @generated from enum value: SQL = 17;
   */
  SQL = 17,

  /**
   * @generated from enum value: OTHER = 9;
   */
  OTHER = 9,
}

/**
 * Describes the enum wt_srv_shared.ConnectorType.
 */
export const ConnectorTypeSchema: GenEnum<ConnectorType> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 5);

/**
 * @generated from enum wt_srv_shared.ConnectorAuthType
 */
export enum ConnectorAuthType {
  /**
   * @generated from enum value: CONNECTOR_AUTH_TYPE_UNSPECIFIED = 0;
   */
  CONNECTOR_AUTH_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SINGLE_ADMIN_TOKEN = 1;
   */
  SINGLE_ADMIN_TOKEN = 1,

  /**
   * @generated from enum value: PER_USER_TOKEN = 2;
   */
  PER_USER_TOKEN = 2,
}

/**
 * Describes the enum wt_srv_shared.ConnectorAuthType.
 */
export const ConnectorAuthTypeSchema: GenEnum<ConnectorAuthType> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 6);

/**
 * @generated from enum wt_srv_shared.ReceivePostedTimeStatus
 */
export enum ReceivePostedTimeStatus {
  /**
   * @generated from enum value: DISABLED = 0;
   */
  DISABLED = 0,

  /**
   * @generated from enum value: WEBHOOK = 1;
   */
  WEBHOOK = 1,

  /**
   * @generated from enum value: LONG_POLL = 2;
   */
  LONG_POLL = 2,
}

/**
 * Describes the enum wt_srv_shared.ReceivePostedTimeStatus.
 */
export const ReceivePostedTimeStatusSchema: GenEnum<ReceivePostedTimeStatus> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 7);

/**
 * @generated from enum wt_srv_shared.SubscriberState
 */
export enum SubscriberState {
  /**
   * @generated from enum value: SUBSCRIBER_STATE_UNSPECIFIED = 0;
   */
  SUBSCRIBER_STATE_UNSPECIFIED = 0,

  /**
   * Default subscription without any restrictions.
   *
   * @generated from enum value: ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * *
   * Usually identifies that subscription has an overdue payment.
   * Provides next restrictions to the team(s) under this subscription:
   *   - It is not possible to post time to the team.
   *   - Members of the team constantly see a warning message re not renewed subscription.
   *
   * @generated from enum value: RESTRICTED = 2;
   */
  RESTRICTED = 2,

  /**
   * @generated from enum value: TRASHED = 3;
   */
  TRASHED = 3,
}

/**
 * Describes the enum wt_srv_shared.SubscriberState.
 */
export const SubscriberStateSchema: GenEnum<SubscriberState> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 8);

/**
 * @generated from enum wt_srv_shared.ManagementSystemType
 */
export enum ManagementSystemType {
  /**
   * @generated from enum value: MANAGEMENT_SYSTEM_TYPE_UNSPECIFIED = 0;
   */
  MANAGEMENT_SYSTEM_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MS_ABACUS_LAW = 1;
   */
  MS_ABACUS_LAW = 1,

  /**
   * @generated from enum value: MS_ACTIONSTEP = 46;
   */
  MS_ACTIONSTEP = 46,

  /**
   * @generated from enum value: MS_ADERANT = 34;
   */
  MS_ADERANT = 34,

  /**
   * @generated from enum value: MS_ALLISA = 37;
   */
  MS_ALLISA = 37,

  /**
   * @generated from enum value: MS_AMBERLO = 47;
   */
  MS_AMBERLO = 47,

  /**
   * @generated from enum value: MS_ANAQUA = 2;
   */
  MS_ANAQUA = 2,

  /**
   * @generated from enum value: MS_ANNO_TEXT = 3;
   */
  MS_ANNO_TEXT = 3,

  /**
   * @generated from enum value: MS_APIGES = 4;
   */
  MS_APIGES = 4,

  /**
   * @generated from enum value: MS_BILL4TIME = 5;
   */
  MS_BILL4TIME = 5,

  /**
   * @generated from enum value: MS_CASEFOX = 48;
   */
  MS_CASEFOX = 48,

  /**
   * @generated from enum value: MS_CLIO = 6;
   */
  MS_CLIO = 6,

  /**
   * @generated from enum value: MS_CLIO_EU = 35 [deprecated = true];
   * @deprecated
   */
  MS_CLIO_EU = 35,

  /**
   * @generated from enum value: MS_COSMOLEX = 7;
   */
  MS_COSMOLEX = 7,

  /**
   * @generated from enum value: MS_DYNAMICS_365_BUSINESS_CENTRAL_CLOUD = 44;
   */
  MS_DYNAMICS_365_BUSINESS_CENTRAL_CLOUD = 44,

  /**
   * @generated from enum value: MS_DYNAMICS_365_BUSINESS_CENTRAL_ON_PREM = 45;
   */
  MS_DYNAMICS_365_BUSINESS_CENTRAL_ON_PREM = 45,

  /**
   * @generated from enum value: MS_ELITE = 8;
   */
  MS_ELITE = 8,

  /**
   * @generated from enum value: MS_EFILIA_IP = 39;
   */
  MS_EFILIA_IP = 39,

  /**
   * @generated from enum value: MS_EQUINOX = 9;
   */
  MS_EQUINOX = 9,

  /**
   * @generated from enum value: MS_EXPERT = 10;
   */
  MS_EXPERT = 10,

  /**
   * @generated from enum value: MS_FILEVINE = 49;
   */
  MS_FILEVINE = 49,

  /**
   * @generated from enum value: MS_FOUNDATION_IP = 11;
   */
  MS_FOUNDATION_IP = 11,

  /**
   * @generated from enum value: MS_GENESE = 12;
   */
  MS_GENESE = 12,

  /**
   * @generated from enum value: MS_HIGHQ = 50;
   */
  MS_HIGHQ = 50,

  /**
   * @generated from enum value: MS_INPROTECH = 13;
   */
  MS_INPROTECH = 13,

  /**
   * @generated from enum value: MS_INSIGHTLY = 38;
   */
  MS_INSIGHTLY = 38,

  /**
   * @generated from enum value: MS_ITIMEKEEP = 51;
   */
  MS_ITIMEKEEP = 51,

  /**
   * @generated from enum value: MS_JIRA = 14;
   */
  MS_JIRA = 14,

  /**
   * @generated from enum value: MS_JIRA_CLOUD = 15;
   */
  MS_JIRA_CLOUD = 15,

  /**
   * @generated from enum value: MS_JURIS = 33;
   */
  MS_JURIS = 33,

  /**
   * @generated from enum value: MS_LAWCUS = 43;
   */
  MS_LAWCUS = 43,

  /**
   * @generated from enum value: MS_LAWGRO = 52;
   */
  MS_LAWGRO = 52,

  /**
   * @generated from enum value: MS_LEAP = 16;
   */
  MS_LEAP = 16,

  /**
   * @generated from enum value: MS_LEXISNEXIS = 53;
   */
  MS_LEXISNEXIS = 53,

  /**
   * @generated from enum value: MS_LITIFY = 54;
   */
  MS_LITIFY = 54,

  /**
   * @generated from enum value: MS_MERUSCASE = 55;
   */
  MS_MERUSCASE = 55,

  /**
   * @generated from enum value: MS_MITRATECH = 42;
   */
  MS_MITRATECH = 42,

  /**
   * @generated from enum value: MS_MYCASE = 56;
   */
  MS_MYCASE = 56,

  /**
   * @generated from enum value: MS_MYOB = 17;
   */
  MS_MYOB = 17,

  /**
   * @generated from enum value: MS_NEBULAW = 57;
   */
  MS_NEBULAW = 57,

  /**
   * @generated from enum value: MS_NOT_APPLICABLE = 36;
   */
  MS_NOT_APPLICABLE = 36,

  /**
   * @generated from enum value: MS_ORION = 18;
   */
  MS_ORION = 18,

  /**
   * @generated from enum value: MS_OTHER = 19;
   */
  MS_OTHER = 19,

  /**
   * @generated from enum value: MS_PATORG = 20;
   */
  MS_PATORG = 20,

  /**
   * @generated from enum value: MS_PATRAWIN = 21;
   */
  MS_PATRAWIN = 21,

  /**
   * @generated from enum value: MS_PATRICIA = 22;
   */
  MS_PATRICIA = 22,

  /**
   * @generated from enum value: MS_PATTSYWAVE = 58;
   */
  MS_PATTSYWAVE = 58,

  /**
   * @generated from enum value: MS_PCLAW = 23;
   */
  MS_PCLAW = 23,

  /**
   * @generated from enum value: MS_PERFECTLAW = 59;
   */
  MS_PERFECTLAW = 59,

  /**
   * @generated from enum value: MS_PRACTICE_PANTHER = 40;
   */
  MS_PRACTICE_PANTHER = 40,

  /**
   * @generated from enum value: MS_ROCKET_MATTER = 41;
   */
  MS_ROCKET_MATTER = 41,

  /**
   * @generated from enum value: MS_PRACTICE_PARTNER = 24;
   */
  MS_PRACTICE_PARTNER = 24,

  /**
   * @generated from enum value: MS_PROLAW = 25;
   */
  MS_PROLAW = 25,

  /**
   * @generated from enum value: MS_QUICKBOOKS = 26;
   */
  MS_QUICKBOOKS = 26,

  /**
   * @generated from enum value: MS_RIPPE_KINGSTON = 27;
   */
  MS_RIPPE_KINGSTON = 27,

  /**
   * @generated from enum value: MS_SIMPLELAW = 60;
   */
  MS_SIMPLELAW = 60,

  /**
   * @generated from enum value: MS_SMOKEBALL = 61;
   */
  MS_SMOKEBALL = 61,

  /**
   * @generated from enum value: MS_SPINELEGAL = 62;
   */
  MS_SPINELEGAL = 62,

  /**
   * @generated from enum value: MS_SUREPOINT_TECHNOLOGIES = 63;
   */
  MS_SUREPOINT_TECHNOLOGIES = 63,

  /**
   * @generated from enum value: MS_TABS3 = 28;
   */
  MS_TABS3 = 28,

  /**
   * @generated from enum value: MS_TIMESLIPS = 64;
   */
  MS_TIMESLIPS = 64,

  /**
   * @generated from enum value: MS_TIMESOLV = 29;
   */
  MS_TIMESOLV = 29,

  /**
   * @generated from enum value: MS_WINPAT = 30;
   */
  MS_WINPAT = 30,

  /**
   * @generated from enum value: MS_XERO = 31;
   */
  MS_XERO = 31,

  /**
   * @generated from enum value: MS_ZOLA_SUITE = 32;
   */
  MS_ZOLA_SUITE = 32,
}

/**
 * Describes the enum wt_srv_shared.ManagementSystemType.
 */
export const ManagementSystemTypeSchema: GenEnum<ManagementSystemType> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 9);

/**
 * Represents the rights a user has within a Team.
 * https://support.practiceinsight.io/jira/browse/WT-5225
 *
 * @generated from enum wt_srv_shared.Authority
 */
export enum Authority {
  /**
   * @generated from enum value: AUTHORITY_UNSPECIFIED = 0;
   */
  AUTHORITY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEMBER = 1;
   */
  MEMBER = 1,

  /**
   * @generated from enum value: USER_ADMIN = 5;
   */
  USER_ADMIN = 5,

  /**
   * @generated from enum value: MANAGER = 2;
   */
  MANAGER = 2,

  /**
   * @generated from enum value: OWNER = 3;
   */
  OWNER = 3,

  /**
   * system admin at Practice Insight
   *
   * @generated from enum value: SYSADMIN = 4 [deprecated = true];
   * @deprecated
   */
  SYSADMIN = 4,
}

/**
 * Describes the enum wt_srv_shared.Authority.
 */
export const AuthoritySchema: GenEnum<Authority> = /*@__PURE__*/
  enumDesc(file_wt_svc_shared_shared, 10);

